import { useLang } from "../context/LanguageContext";

const OPTIONS = [
  { id: "en", label: "EN", full: "English" },
  { id: "es", label: "ES", full: "Español" },
];

export default function LanguageToggle({ variant = "desktop" }) {
  const { lang, setLang } = useLang();
  const isMobile = variant === "mobile";
  return (
    <div
      role="group"
      aria-label="Language / Idioma"
      className={`inline-flex items-center gap-0.5 p-1 rounded-full border ${isMobile ? "border-granite/15 bg-cream" : "border-granite/15 bg-cream-50"}`}
      data-testid="language-toggle"
    >
      {OPTIONS.map((opt) => {
        const active = lang === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            onClick={() => setLang(opt.id)}
            title={opt.full}
            aria-pressed={active}
            data-testid={`lang-btn-${opt.id}`}
            className={`px-3 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider transition-colors ${
              active
                ? "bg-brand text-cream shadow-sm"
                : "text-granite/60 hover:text-brand"
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
